import { Injectable } from '@angular/core';
import { Converter } from '../../converter.interface';
import { isNullOrUndefined } from 'util';
import { AddressesObject } from 'src/app/models/orders/order-details-sites/sites-table/sites-address-table/addresses-object.model';
import { CharacteristicsConverter } from '../../characteristics/characteristics.converter';

@Injectable({
    providedIn: 'root'
})
export class OrderDetailsSitesAddressesConverter implements Converter<Array<AddressesObject>> {

    constructor(private characteristicsConverter: CharacteristicsConverter) { }

    convert(input: any): Array<AddressesObject> {
        if (isNullOrUndefined(input)) {
            return new Array<AddressesObject>();
        }

        const addressList = new Array<AddressesObject>();
        for (const address of input.addresses) {
            const newFormat = address.name + ' (' + address.version + ')';
            const characteristics = this.characteristicsConverter.convert(address.characteristics);
            addressList.push(new AddressesObject(newFormat, characteristics));
        }

        return addressList;
    }
}